import React from 'react'
import "./styles/footer.css"
export const Footer = () => {
    return (
        <footer id="foot">
            <p> Copyright © All rights reserved.</p>
        </footer>
    )
}
